import { render } from "./TheAposSavingIndicator.vue?vue&type=template&id=c0553e1e&scoped=true"
import script from "./TheAposSavingIndicator.vue?vue&type=script&lang=js"
export * from "./TheAposSavingIndicator.vue?vue&type=script&lang=js"

import "./TheAposSavingIndicator.vue?vue&type=style&index=0&id=c0553e1e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0553e1e"],['__file',"admin-bar/ui/apos/components/TheAposSavingIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0553e1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0553e1e', __exports__)) {
    api.reload('c0553e1e', __exports__)
  }
  
  module.hot.accept("./TheAposSavingIndicator.vue?vue&type=template&id=c0553e1e&scoped=true", () => {
    api.rerender('c0553e1e', render)
  })

}


export default __exports__